<span class="urc-pill" [attr.aria-label]="ariaLabel">{{ text }}</span>
